import { Search, Filter } from 'lucide-preact'
import { BRAND_CLASSES } from '@/constants/theme'

interface Props {
  searchQuery: string
  onSearchChange: (value: string) => void
  typeFilter: string
  onTypeChange: (value: string) => void
  availableTypes: string[]
}

/**
 * ORB-457: search box (by name) + type dropdown for the web asset list. Presentational only —
 * the filter state and logic live in useAssetSearchFilter.
 */
export function AssetFilterBar({ searchQuery, onSearchChange, typeFilter, onTypeChange, availableTypes }: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
        <input
          type="text"
          placeholder="Search assets..."
          value={searchQuery}
          onInput={(e) => onSearchChange(e.currentTarget.value)}
          aria-label="Search assets by name"
          className={`w-full pl-10 pr-4 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 ${BRAND_CLASSES.FOCUS.PRIMARY} focus:border-transparent`}
        />
      </div>
      <div className="flex items-center gap-2">
        <Filter className="w-4 h-4 text-slate-400 flex-shrink-0" />
        <select
          value={typeFilter}
          onChange={(e) => onTypeChange(e.currentTarget.value)}
          aria-label="Filter assets by type"
          className={`px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-white focus:outline-none focus:ring-2 ${BRAND_CLASSES.FOCUS.PRIMARY} focus:border-transparent`}
        >
          <option value="all">All types</option>
          {availableTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
